import visionInsuranceReducers from './vision_insurance';
import tabReducers from './tab';

const rpaReducers = {
  ...visionInsuranceReducers,
  ...tabReducers
};

export default rpaReducers;